module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en-US":{"title_index":"Frequently Asked Questions / FAQ","title_form":"Create new question"},"pt-BR":{"title_index":"Dúvidas Frequentes / FAQ","title_form":"Cadastrar nova pergunta"}}')
  delete Component.options._Ctor
}
